import {AxiosResponse, AxiosPromise} from 'axios';
import {createAction, createReducer} from 'redux-act';

import {API_URL, HTTP_REQUEST_HEADER} from 'constants/api';
import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';

import {OAuthPrescriptionsType} from '../../../../../reducers/oAuth/oAuthType';
import {NONE} from '../prescription/constants';
import {PrescriptionType} from '../prescription/prescriptionTypes';

export type SavedPrescriptionsType = {
    status: '' | 'pending' | 'fulfilled' | 'rejected';
    prescriptions: PrescriptionType[];
};

export const initialState: SavedPrescriptionsType = {
    status: '',
    prescriptions: [],
};

export const fetchSavedCustomerPrescriptions = createAction<AxiosPromise<void>>(
    'FETCH_SAVED_CUSTOMER_PRESCRIPTIONS',
    () =>
        instanceGusaBackend.request({
            method: 'GET',
            headers: {
                [HTTP_REQUEST_HEADER.AUTHORIZATION]: '',
            },
            url: `${ENDPOINTS.CUSTOMER_GET_SET_PRESCRIPTIONS}`,
        }),
);

export const saveCustomerPrescription = createAction<AxiosPromise<PrescriptionType>>(
    'SAVE_CUSTOMER_PRESCRIPTION',
    (prescription: PrescriptionType) =>
        instanceGusaBackend.request({
            method: 'POST',
            headers: {
                [HTTP_REQUEST_HEADER.AUTHORIZATION]: '',
            },
            url: `${ENDPOINTS.CUSTOMER_GET_SET_PRESCRIPTIONS}`,
            data: prescription,
        }),
);

export const startSavePrescriptionSaga = createAction<{
    prescription: PrescriptionType;
    isUpdate: boolean;
}>(
    'START_SAVE_CUSTOMER_PRESCRIPTION_SAGA',
    ({prescription, isUpdate}: {prescription: PrescriptionType; isUpdate: boolean}) => ({
        prescription,
        isUpdate,
    }),
);

export const updateCustomerPrescription = createAction<
    Omit<OAuthPrescriptionsType, 'type' | 'updatedAt' | 'isSixoversix' | 'createdAt'>,
    AxiosPromise<{prescription: PrescriptionType; id: number}>
>('UPDATE_CUSTOMER_SAVED_PRESCRIPTION', prescription =>
    instanceGusaBackend.request({
        method: 'PUT',
        baseURL: API_URL,
        url: `${ENDPOINTS.CUSTOMER_PRESCRIPTIONS}/${prescription.id}`,
        data: prescription,
    }),
);

/**
 * Contains all saved prescriptions of logged customer
 */
export const savedCustomerPrescriptions = createReducer<SavedPrescriptionsType>(
    {
        [`${fetchSavedCustomerPrescriptions}_FULFILLED`]: (
            state: SavedPrescriptionsType,
            {data}: AxiosResponse<PrescriptionType[]>,
        ): SavedPrescriptionsType => {
            const prescriptions = data.map(prescription => ({
                ...prescription,
                isMultiPD: prescription.pd.left !== NONE || prescription.pd.right !== NONE,
            }));

            return {
                prescriptions,
                status: 'fulfilled',
            };
        },
        [`${fetchSavedCustomerPrescriptions}_PENDING`]: (state: SavedPrescriptionsType) => ({
            ...state,
            status: 'pending',
        }),
        [`${fetchSavedCustomerPrescriptions}_REJECTED`]: (state: SavedPrescriptionsType) => ({
            ...state,
            status: 'rejected',
        }),
    },
    initialState,
);
